export default __webpack_public_path__ + "static/media/fj.a58ca2ed.svg";